import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { debounceTime, filter, first, map } from 'rxjs/operators';

// Services
import { ComputerService } from '@toro/common/shared/services/computer/computer.service';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { StocksMarketInteractionsService } from '../../../partials/stock/services/stocks-market-interactions.service';

// Interfaces
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { IStressResponse } from '@toro/common/shared/interfaces/pos-risk/stress.interface';

// Components
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { StockCardsComponent } from '../../../partials/stock-cards/stock-cards.component';
import { DialogBuyAndSellConfirmationComponent } from '../../../partials/stock/dialogs/dialog-buy-and-sell-confirmation/dialog-buy-and-sell-confirmation.component';

// Enums
import { KeyStocks } from '@toro/common/shared/enum/key-stocks/key-stocks.enum';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { OrderPriceTypeEnum } from '@toro/common/shared/enum/orders/price-type.enum';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';

// Models
import { ComputingParameter } from '@toro/common/shared/models/computing-parameter/computing-parameter.model';
import { StockCheckoutType } from '@toro/common/shared/models/stocks-exchange/stock-checkout.model';
import { DialogBuyAndSellConfirmation } from '../../../partials/stock/dialogs/dialog-buy-and-sell-confirmation/dialog-buy-and-sell-confirmation.model';

// RX
import { ApplicationMessagesAction } from '@toro/common/shared/state-management/application-messages/application-message.action';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { ResumeGroupmentCardsDialogComponent } from '../../../partials/stock/dialogs/resume-groupment-cards-dialog/resume-groupment-cards-dialog.component';
import { ExchangeActions } from '../../../state-management/exchange/exchange.action';
import { ExchangeEffects } from '../../../state-management/exchange/exchange.effects';
import { StocksExchangeCheckoutAction } from '../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';

@AutoUnsubscribe()
@Component({
    selector: 'unplanned-card',
    templateUrl: './unplanned-card.component.html',
    styleUrls: ["./unplanned-card.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class UnplanedCardComponent extends StockCardsComponent implements OnDestroy  {

    @ViewChild('elementCard', {static: true}) public elementCard: ElementRef;
    @Input() public investType: any;
    @Input() public brokerageModel: number;
    @Input() public isGroupmentCard: boolean = false;
    @Input() public isSettleFutureBalance: boolean = false;
    @Input() public dataToCheckout;
    @Input() public hideAveragePrice: boolean = false;

    public isBuyFromRisk: boolean;
    public symbol: string;
    public symbolLogo: string;
    public symbolName: string;
    public unitPrice: number;
    public symbolQuote: number = 0;
    public sideText: string;
    public isDaytrade: boolean = false;
    public pending: boolean = false;
    public instrument: any = null;
    public variation: number = null;
    public valueVariation: string;
    public currentInvestedValue: number = 0;
    public amount: number = 0;
    public pendingMarket: boolean = false;
    public tryTradeValueOnPending: any = 0;
    public stress: IStressResponse = null;
    public pTaxValue: number = 0;
    public calculateParams: ComputingParameter = null;
    public marketScenario: number = null;
    public calculateScenario: number = null;
    public isFuture: boolean = false;
    public buttonText: string;
    public pendingText: string;
    public redirectText: string;
    public expired: any;
    public dayTrade: any;
    public isPtax: boolean;
    public marketOpen: boolean;
    public isLimited: boolean;
    public marketOpeningTime: string;
    public closeInvestmentModal: MatDialogRef<DialogPanelComponentContent>;
    public currentQty: number;
    public profitOrLoss: string;
    public libMath = Math;
    public realAveragePrice: number = null;
    public blockedSell: boolean = false;

    @Output() valueInvestedStackEvent = new EventEmitter<{}>();

    private quoteSubscription: Subscription;
    private instrumentSubscription: Subscription;
    private readonly stressSubscription: Subscription;
    private pTaxSubscription: Subscription;
    private cancelOrderSuccessSubsctiption: Subscription;
    private averagePriceSubscription: Subscription;

    constructor(
        protected router: Router,
        protected dialogServices: DialogsService,
        protected store: Store<AppState>,
        protected changeDetectorRef: ChangeDetectorRef,
        private readonly computeService: ComputerService,
        private readonly exchangeEffects: ExchangeEffects,
        private readonly utils: UtilitiesService,
        private readonly interactions: StocksMarketInteractionsService,
        public toastrService: ToastrService,
    ) {
        super(router, dialogServices, store, changeDetectorRef);
    }

    public ngOnInit() {
        this.symbol = this.stockDetails.symbol;
        if (!this.stockDetails.clOrderID) {
            const leavesQty = Math.abs(this.stockDetails.total);

            this.stockDetails = Object.create(
                Object.getPrototypeOf(this.stockDetails),
                Object.getOwnPropertyDescriptors(this.stockDetails)
            );
            this.stockDetails.leavesQty = leavesQty;

            if (this.symbol) {
                this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.symbol });
                this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.symbol });
            }
        } else {
            this.pending = true;
            this.amount = this.stockDetails.leavesQty;

            if (this.stockDetails.priceType === OrderPriceTypeEnum.Limited) {
                this.tryTradeValueOnPending = this.stockDetails.price;
                this.unitPrice = this.stockDetails.price;
            } else {
                this.pendingMarket = true; // se o pricetype é market
            }

            if (this.symbol) {
                this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.symbol });
                this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.symbol });
            }
        }

        this.isDaytrade = this.stockDetails.isDayTrade;
        this.currentQty = this.stockDetails.leavesQty  || this.stockDetails.orderQty;
        this.isBuyFromRisk = this.stockDetails.side === OrderSideEnum.Compra;

        this.setLabels()
        this.bindQuoteSubscription();
        this.bindInstrumentSubscription();
        this.bindPTaxSubscription();
        this.bindAveragePriceSubscription();


        this.onHide.subscribe(() => {
            this.ngOnDestroy();
        });
    }

    public ngAfterViewInit() {
    if (this.instrument && this.instrument.blockedQuantity === this.currentQty) {
        this.blockedSell = true;
    }
  }

    public bindQuoteSubscription = () => {
        this.quoteSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.quote)
            .pipe(
                filter((item) => this.stockDetails && item[this.symbol]),
                map((item) => item[this.symbol])
            )
            .subscribe((data) => {
                Promise.resolve().then(() => {
                    const quote = data;
                    this.stress = this.utils.normalize(quote.Stress);
                    this.isPtax = quote.Stress.IsPtax;

                    const price = quote.PriceLastTrade || quote.OpeningPrice || quote.ClosingPricePreviousDay;
                    if (price != null)
                        this.symbolQuote = price;
                    if (quote.variation != null)
                        this.variation = Math.abs(quote.Variation);

                    if (quote.Variation === 0) {
                        this.valueVariation = 'normal';
                    } else {
                        this.valueVariation = quote.Variation > 0 ? 'high' : 'low';
                    }

                    this.currentInvestedValue = this.calculateCurrentInvestedValue();

                    if(this.instrument && this.instrument.code && this.currentInvestedValue) {
                        this.valueInvestedStackEvent.emit({
                            symbol: this.instrument.code, investedValue: this.currentInvestedValue
                        });
                    }
                    this.changeDetectorRef.detectChanges();
                });
            });
    }

    public bindInstrumentSubscription = () => {
        this.instrumentSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.instruments)
            .pipe(
                filter((item) => this.stockDetails && item[this.symbol] ? true : false),
                map((item) => item[this.symbol]),
                first()
            )
            .subscribe((instrument) => {
                Promise.resolve().then(() => {
                    this.instrument = instrument;
                    this.symbolLogo = this.instrument.logo.content;
                    this.symbolName = this.instrument.descriptionStock;
                    this.isFuture = this.instrument.typeMarket === OrderMarketTypeEnum.Future;
                    this.stress = instrument.stress;
                    this.isPtax = this.stress.isPtax;
                    if (this.stress.isPtax) {
                        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: KeyStocks.DolPtax });
                    }

                    if(!this.symbolQuote && instrument.priceLastTrade)
                        this.symbolQuote = instrument.priceLastTrade;

                    if (instrument.variation != null) this.variation = Math.abs(instrument.variation);
                    if (instrument.variation === 0) {
                        this.valueVariation = 'normal';
                    } else {
                        this.valueVariation = instrument.variation > 0 ? 'high' : 'low';
                    }
                    this.currentInvestedValue = this.calculateCurrentInvestedValue();

                    if (this.instrument.blockedQuantity === this.currentQty) {
                        this.blockedSell = true;
                    }

                    this.changeDetectorRef.detectChanges();
                });
            });
    }

    public bindPTaxSubscription = () => {
        this.pTaxSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.quote)
            .pipe(
                filter((item) => this.stockDetails && item[KeyStocks.DolPtax]),
                map((item) => item[KeyStocks.DolPtax]),
                debounceTime(300)
            )
            .subscribe((data) => {
                this.pTaxValue = data.PriceLastTrade || data.OpeningPrice || data.ClosingPricePreviousDay;
            });
    }

    public bindAveragePriceSubscription = () => {
        this.averagePriceSubscription = this.store
            .select((state) => state.custodyAveragePrice)
            .pipe(
                filter((custodyAveragePrice) =>
                    !custodyAveragePrice.pending &&
                    !!custodyAveragePrice.custodyAveragePrice.length
                ),
            )
            .subscribe((custodyAveragePrice) => {
                const custodyData = custodyAveragePrice.custodyAveragePrice
                    .find((obj) => obj.ticker === this.symbol || obj.ticker+'F' === this.symbol);

                if (custodyData) {
                    this.realAveragePrice = custodyData.price;
                }
            });
    }

    /**
     * Calcula o valor minimo para investir
     */
    public calculateCurrentInvestedValue() {
        let result = 0;
        if (!this.isBuyFromRisk && !this.pending && !this.isDaytrade && !this.isFuture) {
            result = Math.abs(this.stockDetails.total) * this.symbolQuote;
        } else {
            this.fillCalculateParams(this.unitPrice || this.symbolQuote);
            if (!this.calculateParams) return 0;
            result = this.computeService.calculate(this.marketScenario, this.calculateScenario, this.calculateParams);
        }
        return Number.isFinite(result) ? result : NaN;
    }

    /**
     * Preenche os dados do calculateParam
     */
    public fillCalculateParams(unitPrice) {
        if (!this.instrument || !(this.unitPrice || this.symbolQuote) || !this.stress) return;

        const amountToCalculate = this.stockDetails.executedAmount ||
            this.stockDetails.cumQty ||
            this.stockDetails.leavesQty ||
            this.stockDetails.orderQty;

        this.marketScenario = this.computeService.computeMarketScenario(this.instrument.typeMarket, this.stress.isPtax);
        this.calculateScenario = this.computeService.computeCalculatingScenario(
            this.stockDetails.side === OrderSideEnum.Compra,
            this.isDaytrade,
            false,
        );
        this.calculateParams = new ComputingParameter(
            amountToCalculate,
            unitPrice, // Parametro
            this.instrument.quoteFactor,
            this.isDaytrade ? this.stress.dayTradeValue : this.stress.value,
            null, // para não estratégia nao precisamos de loss price no calculo
            this.isPtax ? this.pTaxValue : null,
        );
    }

    public buttonAction() {
        if (this.pending) {
            const side = (this.isBuyFromRisk) ? 'compra' : 'venda';
            const title = `Cancelar a ${side}`;
            const message = `Cancelar a ${side} é uma ação que você não pode desfazer. Você tem certeza que deseja cancelar este pedido?`;
            this.openModalConfirm(title, message, 'Cancelar pedido', 'Voltar')
                .subscribe((result) => {
                    if (result) {
                        this.cancelOrder();
                    }
                });
        } else {
            return this.interactions.onInvestmentAttempt(this.instrument.typeMarket , !this.isBuyFromRisk)
                .then( (goAHead) => {
                    if (goAHead.confirm) {
                        this.marketOpen = goAHead.market.marketOpen;
                        this.marketOpeningTime = goAHead.market.openingTime;
                        this.openBuyAndSellConfirmationDialog();
                    }
                });
        }
    }

    /**
     * Modal: Comprar/Vender
     * Esse modal abre qual for clicado no botão de 'Comprar/Vender'.
     */
    public openBuyAndSellConfirmationDialog() {
        const settings = new DialogBuyAndSellConfirmation(
            !this.isBuyFromRisk, // compra
            null, // orderId não é usado
            this.symbol,
            this.symbolName,
            this.stockDetails.leavesQty - this.instrument.blockedQuantity,
            this.instrument.typeMarket,
            this.instrument.standardLot,
            +this.instrument.rangeMinimumPriceIncrements,
            this.isDaytrade,
            this.marketOpen,
            this.marketOpeningTime,
        );
        this.closeInvestmentModal = this.dialogsService.showComponentAsAsidePanel(DialogBuyAndSellConfirmationComponent, true, settings);
    }

    public openModalAgroupment() {
        this.dialogsService.showComponnent(ResumeGroupmentCardsDialogComponent, this.stockDetails);
    }

    public settleButtonAction() {
        this.stockDetails.leavesQty = Math.abs(this.dataToCheckout.total);
        this.isDaytrade = this.dataToCheckout.isDaytrade;
        this.openBuyAndSellConfirmationDialog();
    }

    public get getResult() {
        const averagePrice = this.realAveragePrice ?? this.stockDetails.averagePrice;

        if(this.symbolQuote && averagePrice && this.stockDetails.leavesQty) {
            return (this.symbolQuote - averagePrice) * this.stockDetails.leavesQty;
        }

        return undefined;
    }

    public get blockSettleButton() {
        if(this.dataToCheckout) {
            return this.stockDetails.side !== this.dataToCheckout.side
        }
        return false;
    }

    /**
     * Abre modal de confirmação
     */
    public openModalConfirm(title: string, message: string, confirm: string, cancel: string = 'Cancelar'): Observable<boolean> {
        return this.dialogsService.confirmAction(title, message, confirm, cancel);
    }

    /**
     * Abre modal simples
     */
    public openModalSimple(title: string, message: string, button: string) {
        return this.dialogsService.showSimpleModal(title, message, button);
    }

    public ngOnDestroy() {
        if (this.closeInvestmentModal) this.closeInvestmentModal.close();
    }

    public goToStockTracking() {
        if (this.pending) {
            // tslint:disable-next-line: prefer-const
            let item = new StockCheckoutType();
            item.orderId = this.stockDetails.id || this.stockDetails.iD;
            item.symbol = this.symbol;
            this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item});
            this.router.navigate(['/checkout/editar']);
        } else {
            // tslint:disable-next-line: prefer-const
            let params = ['/', 'acompanhamento', this.symbol];
            params.push( this.isBuyFromRisk ? 'compra' : 'venda');

            if (this.isDaytrade) params.push('encerra-hoje');

            this.router.navigate(params);
        }
    }

    public get absoluteResult() {
        const ptax = this.isPtax ? this.pTaxValue: 1;
        return this.computeService.ComputeResultValue(
            this.currentQty,
            this.instrument.quoteFactor,
            this.symbolQuote,
            this.stockDetails.averagePrice,
            this.isFuture,
            this.stockDetails.side === OrderSideEnum.Compra,
            ptax,
        );
    }

    public get resultLabel() {
        if(!this.absoluteResult) return 'zero';
        return this.absoluteResult > 0 ? 'profit' : 'loss';
    }

    public setLabels () {
        if (this.isBuyFromRisk) {
            if (this.pending) {
                this.sideText = 'COMPRA';
                this.buttonText = 'Cancelar o pedido';
                this.redirectText = 'Editar compra';
            } else {
                this.sideText = 'COMPRADO';
                this.buttonText = 'Vender';
                this.redirectText = 'Mais detalhes';
            }
            this.pendingText = !this.pendingMarket ? 'TENTANDO COMPRAR A' : 'TENTANDO COMPRAR NO MELHOR PREÇO DISPONÍVEL';
        } else {
            if (this.pending) {
                this.sideText = 'VENDA';
                this.buttonText = 'Cancelar o pedido';
                this.redirectText = 'Editar venda';
            } else {
                this.sideText = 'VENDIDO';
                this.buttonText = 'Comprar';
                this.redirectText = 'Mais detalhes';
            }
            this.pendingText = !this.pendingMarket ?  'TENTANDO VENDER A' : 'TENTANDO VENDER NO MELHOR PREÇO DISPONÍVEL';
        }
    }

    private cancelOrder() {
        const orderID = this.stockDetails.id || this.stockDetails.iD;
        this.store.dispatch({ type: ExchangeActions.cancelOrder, payload: {orderId: orderID} });
        const side = (this.isBuyFromRisk) ? 'compra' : 'venda';

        this.cancelOrderSuccessSubsctiption = this.exchangeEffects.cancelOrder$
            .pipe(
                filter((item) => item.type.equals(ExchangeActions.cancelOrderSuccess))
            )
            .subscribe((data) => {
                this.onHide.emit(true);
                this.showToastCancelSuccess(side);
            });

        this.cancelOrderSuccessSubsctiption = this.exchangeEffects.cancelOrder$
            .pipe(
                filter((item) => item.type.equals(ExchangeActions.cancelOrderError))
            )
            .subscribe((result: ExchangeActions) => {
                this.store.dispatch({ type: ApplicationMessagesAction.genericError, payload: result.payload });
            });
    }

    private showToastCancelSuccess(side: string) {
        this.toastrService.success(
            `Você cancelou o seu pedido de ${side}`, '', {
                timeOut: 7000,
                progressBar: true,
                positionClass: 'toast-bottom-center',
                toastClass: 'toast--default font-small--medium font-light-color',
            },
        );
    }

}
